import { React, useState, useEffect } from "react";
import { Space, SpinLoading } from 'antd-mobile'
import { BrowserRouter } from "react-router-dom"
import { Router } from 'pages/router/'
import { isUnEmptyObject } from 'utils/is'
import { UserContext } from 'utils/getContext'
import { getQueryString } from 'utils/index'
import { getLoginParam } from 'api/api'
import './App.css';

/**入口 */
function App() {
  const [userInfo, setUserInfo] = useState() // 用户信息
  const [loginInfo, setLoginInfo] = useState() // 登录信息
  const [loading, setLoading] = useState(true) // 加载中

  const isCheckLogin = sessionStorage.getItem('isCheckLogin') === 'true' ? true : false


  useEffect(() => {
    getLoginParam().then((res) => {
      const loginInfo = res.data
      setLoginInfo(loginInfo)
      if (isUnEmptyObject(loginInfo)) {
        const { redirectUrl, requestParams, appContext } = loginInfo
        const locationOrigin = window.location.origin
        // 获取上下文路径,移动端上下文默认均为app
        const context = appContext || '/app'
        // 获取当前页面的路由
        const pathname = window.location.pathname
        const router = pathname.replace(context, '')

        if (router === '/checkLogin') {
          const urlLoginFlag = getQueryString('loginFlag')
          const flag = urlLoginFlag === 'true'
          localStorage.setItem('isLogin', flag)
        } else {
          sessionStorage.removeItem('isLogin')
          sessionStorage.removeItem('isCheckLogin')
          const checkbackurl = `checkbackurl=${locationOrigin}${context}/checkLogin?router=${router}`
          const checkLoginUrl = `${redirectUrl}${checkbackurl}&${requestParams}`
          window.location.href = encodeURI(checkLoginUrl)
        }
      }
      setLoading(false)
    })
  }, [])


  if (loading) {
    if (isCheckLogin) {
      return (
        <div className="spin-loading" >
          <Space direction='horizontal' wrap block style={{ '--gap': '16px' }}>
            <SpinLoading style={{ '--size': '48px' }} color='primary' />
          </Space>
        </div>
      )
    } else {
      return null
    }
  }


  return (
    <UserContext.Provider value={{ userInfo, setUserInfo, loginInfo }}>
      <BrowserRouter basename='/app'>
        {/* <Home /> */}
        <Router />
      </BrowserRouter>
    </UserContext.Provider >
  )
}

export default App;
